import React from "react";
import "./AnalyticsCards.css";

const AnalyticsCards = ({ dashboard }) => {
  const cards = [
    {
      title: "Total Revenue",
      value: `₹${(
        dashboard.totalRevenue || 0
      ).toLocaleString()}`,
      icon: "💰",
      color: "#16a34a",
    },
    {
      title: "Total Orders",
      value: dashboard.totalOrders || 0,
      icon: "📦",
      color: "#2563eb",
    },
    {
      title: "Completed Orders",
      value: dashboard.completedOrders || 0,
      icon: "✅",
      color: "#059669",
    },
    {
      title: "Pending Orders",
      value: dashboard.pendingOrders || 0,
      icon: "⏳",
      color: "#d97706",
    },
    {
      title: "Cancelled Orders",
      value: dashboard.cancelledOrders || 0,
      icon: "❌",
      color: "#dc2626",
    },
    {
      title: "Foods",
      value: dashboard.totalFoods || 0,
      icon: "🍽️",
      color: "#7c3aed",
    },
    {
      title: "Reviews",
      value: dashboard.totalReviews || 0,
      icon: "⭐",
      color: "#0891b2",
    },
  ];

  return (
    <div className="analytics-cards">
      {cards.map((card, index) => (
        <div
          className="analytics-card"
          key={index}
        >
          <div
            className="analytics-icon"
            style={{
              background: card.color,
            }}
          >
            {card.icon}
          </div>

          <div className="analytics-info">
            <h4>{card.title}</h4>
            <h2>{card.value}</h2>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AnalyticsCards;